import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';
var defaultBreakpoints = {
  base: true
};
var BreakpointsContext = /*#__PURE__*/React.createContext(defaultBreakpoints);
function BreakpointsProvider(_ref) {
  var breakpointsToWatch = _ref.breakpoints,
    children = _ref.children;
  var _useState = useState(defaultBreakpoints),
    _useState2 = _slicedToArray(_useState, 2),
    breakpoints = _useState2[0],
    setBreakpoints = _useState2[1];
  var mediaQueriesRef = useRef({});
  useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') return;
    var mediaQueries = mediaQueriesRef.current;
    function updateMatches(bp) {
      return function () {
        setBreakpoints(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, bp, mediaQueries[bp].matches));
        });
      };
    }

    // Create a list `mediaQueries` of matchMedia watchers for the breakpoints
    // passed to the component
    Object.keys(breakpointsToWatch).forEach(function (bp) {
      mediaQueries[bp] = window.matchMedia("(min-width: ".concat(breakpointsToWatch[bp], ")"));
      mediaQueries[bp].addListener(updateMatches(bp));
      updateMatches(bp)();
    });
    return function cleanUp() {
      Object.keys(breakpointsToWatch).forEach(function (bp) {
        mediaQueries[bp].removeListener(updateMatches(bp));
      });
    };
  }, [breakpointsToWatch]);
  return /*#__PURE__*/React.createElement(BreakpointsContext.Provider, {
    value: breakpoints
  }, children);
}
export { BreakpointsContext, BreakpointsProvider };